import { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Logo from "../../assets/images/SecuB-logo.svg";
import WebService from "../../Services/WebService";
import PageLoader from "../Common/PageLoader/PageLoader";
import "./loader.scss";
import { profileSettings, SubscriptionDetails } from "../../config/action";
import { useDispatch } from "react-redux";
const VerifyEmail = () => {
  let params = useParams();
  let account_verification_id = params.url;
  let navigate = useNavigate();
  let dispatch = useDispatch();
  useEffect(() => {
    if (account_verification_id) {
      handleVerifyEmail();
    }
  }, []);
  const meCall = () => {
    return WebService.getAPI({
      action: `me`,
      body: null,
    })
      .then((res: any) => {
        dispatch(profileSettings(res?.info));
        dispatch(SubscriptionDetails(res?.subscription));
        localStorage.setItem("first_name", res?.info?.first_name);
        localStorage.setItem("last_name", res?.info?.last_name);
        localStorage.setItem("email", res?.info?.email);
        localStorage.setItem("mobile", res?.info?.mobile);
        localStorage.setItem("dial_code", res?.info?.dial_code);
        localStorage.setItem("profile_photo", res?.info?.profile_photo);
        localStorage.setItem("role", res?.info?.role?.name);
        localStorage.setItem("uuid", res?.info?.company?.uuid);
        if (res?.subscription != null) {
          // toast.success(res?.message)
          navigate("/email-verification-success");
        } else {
          navigate("/plans");
        }
        WebService.removeLoader("verify-btn");
      })
      .catch((error) => {
        console.log(error);
        WebService.removeLoader("verify-btn");
        toast.error(error?.response?.data?.message);
      });
  };
  const handleVerifyEmail = () => {
    return WebService.BeforLoginPostAPI({
      action: `auth/account/verify-link`,
      body: { token: account_verification_id },
    })
      .then((res: any) => {
        localStorage.setItem("access_token", res?.token);
        toast.success(res?.message);
        localStorage.removeItem("singIn_id");
        meCall();
      })
      .catch((error) => {
        console.log(error);
        navigate("/login");
        toast.error(error?.response?.data?.message);
      });
  };
  return (
    <>
      <Container fluid>
        <div className="p-4">
          <img src={Logo} width="145" className="mb-3" alt="Logo" />
        </div>
      </Container>
      <div className="container">
        <div className="verify-email-container" style={{ height: "auto" }}>
          <div className="page-content">
            <div className="loader-container">
              <PageLoader />
            </div>
            <div className="loading-message">Verifying...Please wait...</div>
          </div>
        </div>
      </div>
    </>
  );
};
export default VerifyEmail;
